import { useCallback, useState } from "react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/20/solid";
import ProfessionalSpaceNavMenu from "../../ProfessionalSpaceNavMenu";
import classes from "./classes.module.scss";
import classNames from "classnames";
import ButtonsContainer from "../ButtonsContainer";

export default function ResponsiveMenu() {
	const [isMenuOpen, setIsMenuOpen] = useState(false);

	const toggleMenu = useCallback(() => setIsMenuOpen((prev) => !prev), []);

	return (
		<div className={classes["root"]}>
			<Bars3Icon className={classes["icon"]} onClick={toggleMenu} />

			<div
				onClick={toggleMenu}
				className={classNames(classes["nav-menu-container"], {
					[classes["open"]!]: isMenuOpen,
				})}>
				<div className={classes["header"]}>
					<XMarkIcon className={classes["icon"]} />
				</div>
				<ProfessionalSpaceNavMenu className={classes["nav-menu"]} />
				<ButtonsContainer className={classes["buttons-container-root"]} subClassName={classes["buttons-container-subroot"]} fullwidth />
			</div>
		</div>
	);
}
